import { render, staticRenderFns } from "./popUpModel.vue?vue&type=template&id=5989cadd&"
import script from "./popUpModel.vue?vue&type=script&lang=js&"
export * from "./popUpModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5989cadd')) {
      api.createRecord('5989cadd', component.options)
    } else {
      api.reload('5989cadd', component.options)
    }
    module.hot.accept("./popUpModel.vue?vue&type=template&id=5989cadd&", function () {
      api.rerender('5989cadd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/popUpModel.vue"
export default component.exports